import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography
} from '@mui/material'
import { OrderContext } from 'contexts/OrderContextProvider'
import React, { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

interface Props {
  product: any
}

const ProductCard = ({ product }: Props) => {
  const { pathname } = useLocation()
  const { handleGetProductBin } = useContext(OrderContext)

  useEffect(() => {
    if (product.preferredBin === 'loading') {
      handleGetProductBin(product)
    }
  }, [product.preferredBin])

  const isPicking = pathname.includes('picking')
  const isReceiving = pathname.includes('receiving')

  return (
    <Box sx={{ width: '100%', '& .item-quantity': { textAlign: 'right' } }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <Typography variant='subtitle1' fontWeight='bold'>
              {product.item.refName}
            </Typography>
          </Grid>
          <Grid className='item-quantity' size={{ xs: 6 }}>
            <Typography>Remaining: {product.quantityRemaining}</Typography>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Typography>{product.description}</Typography>
          </Grid>
          <Grid className='item-quantity' size={{ xs: 6 }}>
            <Typography>
              {isPicking && `Committed: ${product.quantityCommitted}`}
              {isReceiving && `Received: ${product.quantityReceived}`}
            </Typography>
          </Grid>
          {isPicking && (
            <>
              <Grid size={{ xs: 6 }}>
                <Box display='flex' alignItems='center'>
                  <Typography sx={{ mr: 1 }}>Bin:</Typography>
                  {product.preferredBin === 'loading' ? (
                    <CircularProgress size={20} />
                  ) : product.preferredBin ? (
                    <Typography variant='body2'>
                      {product.preferredBin}
                    </Typography>
                  ) : (
                    <Typography variant='body2' color='text.secondary'>
                      Scan to Display
                    </Typography>
                  )}
                </Box>
              </Grid>
              <Grid className='item-quantity' size={{ xs: 6 }}>
                <Typography>Picked: {product.quantityPicked}</Typography>
              </Grid>
            </>
          )}
          {isPicking && (
            <>
              <Grid size={{ xs: 6 }}></Grid>
              <Grid className='item-quantity' size={{ xs: 6 }}>
                <Typography>Available: {product.quantityAvailable}</Typography>
              </Grid>
            </>
          )}
        </Grid>
      </CardContent>
    </Box>
  )
}

export default ProductCard
